import getColor from "@insite/mobius/utilities/getColor";
import { mainNavigationStyles } from "@MasterBluePrint/Overrides/Widgets/Header/MainNavigation";
import { css } from "styled-components";

mainNavigationStyles.mobileSearchButton = {
    size: 48,
    buttonType: "solid",
    color: "#f3f3f3",
    css: css`
        padding: 0 .625rem;
    `,
};

mainNavigationStyles.menuItemTypography = {
    css: css`
        text-transform:uppercase;
        color: #002554 !important;
        font-family: 'Roboto', sans-serif;
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.1875rem;
        &:hover {
            color: #2060ad !important;
            text-decoration: underline;
        }
    `,
};

mainNavigationStyles.container = {
    css: css`
        display: flex;
        justify-content: left;
        background: #fff;
    `,
};

mainNavigationStyles.menuItemIcon = {
    css: css`
        display: none; // no down arrows on navigation
    `,
};
